<template lang="pug">
    div
        v-carousel.elevation-3.ma-1(
            height="auto"
            show-arrows-on-hover  
            hide-delimiters
            style="width:auto; border-radius:10px"
        )
            v-carousel-item(
                v-for="n in 5" :key="n"
            )
                v-row.ma-0.pa-3
                    v-col.align-self-center.pa-0(cols="4")
                        v-avatar(width="100%" height="auto"  )
                            img(src="https://via.placeholder.com/96x96?text=Cik Kiah") 
                    v-col.align-self-center(cols="8")
                        h4.black--text.font-weight-regular.text-justify "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                    
</template>
<script>
export default {
    data: () => ({
      model: null,
    }),
}
</script>